import { render, staticRenderFns } from "./Adminshjj.vue?vue&type=template&id=326c453a&scoped=true&"
import script from "./Adminshjj.vue?vue&type=script&lang=js&"
export * from "./Adminshjj.vue?vue&type=script&lang=js&"
import style0 from "./Adminshjj.vue?vue&type=style&index=0&id=326c453a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326c453a",
  null
  
)

export default component.exports